var _path, _path2, _rect, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkOutline16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3639 1.63604C12.8019 0.0739472 10.2692 0.073947 8.7071 1.63604L7.99999 2.34315C7.6482 2.69494 7.37563 3.09596 7.18229 3.52403L8.97412 4.42082C9.07175 4.17937 9.21844 3.95313 9.4142 3.75736L10.1213 3.05026C10.9024 2.26921 12.1687 2.26921 12.9497 3.05026C13.7308 3.83131 13.7308 5.09764 12.9497 5.87868L12.2426 6.58579C12.0469 6.78155 11.8206 6.92824 11.5792 7.02587L12.476 8.8177C12.904 8.62436 13.3051 8.35179 13.6568 8.00001L14.3639 7.2929C15.926 5.7308 15.926 3.19814 14.3639 1.63604Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.4208 7.23073C3.03145 7.42022 2.66649 7.67665 2.34311 8.00003L1.636 8.70714C0.073905 10.2692 0.073905 12.8019 1.636 14.364C3.1981 15.9261 5.73076 15.9261 7.29286 14.364L7.99996 13.6569C8.32334 13.3335 8.57977 12.9685 8.76926 12.5792L7.01238 11.6117C6.91492 11.8409 6.77271 12.0557 6.58575 12.2427L5.87864 12.9498C5.09759 13.7308 3.83126 13.7308 3.05022 12.9498C2.26917 12.1687 2.26917 10.9024 3.05022 10.1214L3.75732 9.41424C3.94429 9.22728 4.15906 9.08507 4.38833 8.98761L3.4208 7.23073Z",
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 10.1213,
  y: 4.46448,
  width: 2,
  height: 8,
  rx: 1,
  transform: "rotate(45 10.1213 4.46448)",
  fill: "currentColor"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.09351,
  cy: 3.93899,
  r: 1,
  transform: "rotate(45 8.09351 3.93899)",
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0607,
  cy: 7.90616,
  r: 1,
  transform: "rotate(45 12.0607 7.90616)",
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.95441,
  cy: 8.07809,
  r: 1,
  transform: "rotate(45 3.95441 8.07809)",
  fill: "currentColor"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.92157,
  cy: 12.0453,
  r: 1,
  transform: "rotate(45 7.92157 12.0453)",
  fill: "currentColor"
})));
export { SvgLinkOutline16 as ReactComponent };